import { useEffect, useState } from "react";
import API, { formatApiError } from "../../lib/api";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { toast } from "sonner";
import HseQuestionField from "./HseQuestionField";

/** One-off company H&S profile — feeds every AI-drafted document. */
export default function HseProfileDialog({ open, onOpenChange, onSaved }) {
  const [fields, setFields] = useState([]);
  const [values, setValues] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    API.get("/hse/profile").then(({ data }) => { setFields(data.fields || []); setValues(data.profile || {}); }).catch(e => toast.error(formatApiError(e)));
  }, [open]);

  const save = async () => {
    setSaving(true);
    try {
      await API.put("/hse/profile", values);
      toast.success("Company H&S profile saved");
      onSaved?.();
      onOpenChange(false);
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="hse-profile-dialog">
        <DialogHeader>
          <DialogTitle className="font-[Chivo]">Company H&amp;S profile</DialogTitle>
          <p className="text-xs text-muted-foreground">Answer once — every policy, assessment and plan is written around these facts. You can update it any time.</p>
        </DialogHeader>
        <div className="grid gap-4 sm:grid-cols-2">
          {fields.map(f => (
            <div key={f.key} className={f.type === "textarea" || f.type === "multiselect" ? "sm:col-span-2" : ""}>
              <HseQuestionField q={f} value={values[f.key]} onChange={v => setValues(s => ({ ...s, [f.key]: v }))} testPrefix="hse-profile" />
            </div>
          ))}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="hse-profile-cancel">Cancel</Button>
          <Button onClick={save} disabled={saving} data-testid="hse-profile-save">{saving ? "Saving…" : "Save profile"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
